function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 11C18.2091 11 20 9.20914 20 7C20 4.79086 18.2091 3 16 3C13.7909 3 12 4.79086 12 7C12 9.20914 13.7909 11 16 11ZM11 8.5C11 10.433 9.433 12 7.5 12C5.567 12 4 10.433 4 8.5C4 6.567 5.567 5 7.5 5C9.433 5 11 6.567 11 8.5ZM10.9113 14.8268C9.13328 16.2941 8 18.5147 8 21C8 21.5523 8.44772 22 9 22H14.1111H23C23.5523 22 24 21.5523 24 21C24 16.5817 20.4183 13 16 13C14.1223 13 12.3957 13.6469 11.0309 14.73C10.9907 14.7619 10.9508 14.7942 10.9113 14.8268ZM7.88889 14C8.26709 14 8.43395 14.4502 8.19721 14.7451C6.82246 16.4579 6 18.6329 6 21C6 21.1053 6.00542 21.2093 6.01601 21.3118C6.05145 21.655 5.80874 22 5.46367 22H0.888889C0.39797 22 0 21.602 0 21.1111C0 17.1838 3.18375 14 7.11111 14H7.88889Z",
  fill: "currentColor"
});

var SvgMeeting = function SvgMeeting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMeeting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meeting.210ed3c0.svg";
export { ForwardRef as ReactComponent };